import { Injectable } from '@angular/core';
import {NetworkFilterService} from '../network/network-filter.service';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class VoipPeerFilterService {

  constructor() { }

  public static mapFilter(voipPeers: any, searchObject: any) {

    const searchableFields = ['voipPeers', 'nodes', 'pCons', 'connections', 'name'];

    const searchObjectCopy = NetworkFilterService.formatSearchObject(searchObject);
    let filteredVoipPeers = _.cloneDeep(voipPeers);

    const filterByName = (voipPeerList, nameObject) => {
      if (nameObject && nameObject.value) {
        voipPeerList = voipPeerList.filter((voipPeer) => {
          return voipPeer.name.toLowerCase().indexOf(nameObject.value.toLowerCase()) > -1;
        });
      }
      return voipPeerList;
    };

    const markfilteredVoipPeers = (voipPeerList, filtered) => {
      voipPeerList = voipPeerList.map((voipPeer) => {
        voipPeer.filtered = isElementFiltered(filtered, voipPeer);
        return voipPeer;
      });
      return voipPeerList;
    };

    const isElementFiltered = (array, searchedObject) => {
      return !!array.find((arrayItem) => {
        return arrayItem.id === searchedObject.id;
      });
    };

    if (!searchObjectCopy) {
      return filteredVoipPeers;
    }

    if (searchObjectCopy.freeText) {
      searchObjectCopy.name = {value: searchObjectCopy.freeText};
      filteredVoipPeers = filterByName(filteredVoipPeers, searchObjectCopy.name);
      return markfilteredVoipPeers(voipPeers, filteredVoipPeers);
    }

    if (!searchObjectCopy.voipPeers) {
      return markfilteredVoipPeers(voipPeers, []);
    }

    if (NetworkFilterService.haveNonSearchableFields(searchObjectCopy, searchableFields)) {
      return markfilteredVoipPeers(voipPeers, []);
    }

    if (!searchObjectCopy.voipPeers.value || searchObjectCopy.voipPeers.value === 'no') {
      return markfilteredVoipPeers(voipPeers, []);
    }

    filteredVoipPeers = filterByName(filteredVoipPeers, searchObjectCopy.name);
    return markfilteredVoipPeers(voipPeers, filteredVoipPeers);
  }

  public static testRouteFilter(voipPeers, testRoutePath) {
    return voipPeers;
  }
}
